module.exports = __webpack_public_path__ + "img/12.82f93c24.png";